import { connect } from 'react-redux'
import {
  setSelectedJob,
  setHoveredJob,
  setDeletingJob,
  deleteJob,
  setAddJobLocation,
  getPriorityNumberForJob,
  getIsJobDeleting,
  getIsJobSelected,
} from '../../../modules/job'
import { recordAuditEvent } from '../../../modules/audit'
import { selectProductForJob } from '../../../modules/product'

const mapStateToProps = (state, props) => ({
  isSelected: getIsJobSelected(state, props),
  isDeleting: getIsJobDeleting(state, props),
  product: selectProductForJob(state, props),
  priorityNumber: getPriorityNumberForJob(state, props),
})

const mapDispatchToProps = (dispatch) => ({
  dispatchRecordJobClicked: (jobId) =>
    dispatch(
      recordAuditEvent.request({
        resource: 'job',
        action: 'read',
        resourceId: jobId,
      })
    ),
  dispatchRecordAssessmentHovered: (jobId) =>
    dispatch(
      recordAuditEvent.request({
        resource: 'job',
        action: 'read',
        resourceId: jobId,
      })
    ),
  dispatchSetSelectedJob: (jobId) => dispatch(setSelectedJob(jobId)),
  dispatchSetHoveredJob: (jobId) => dispatch(setHoveredJob(jobId)),
  dispatchSetDeletingJob: (jobId) => dispatch(setDeletingJob(jobId)),
  dispatchDeleteJob: (jobId) => dispatch(deleteJob.request(jobId)),
  dispatchSetAddJobLocation: (location) => dispatch(setAddJobLocation(location)),
})

const redux = connect(mapStateToProps, mapDispatchToProps)

export { redux }
